<!-- Skip link - accessible navigation bypass -->
<chef-skip-link></chef-skip-link>

@if (headerFooterOptions().isLoggedIn) {
  <app-header [options]="headerFooterOptions()"></app-header>
} @else {
  <lib-centered-header [options]="headerFooterOptions()"></lib-centered-header>
}
<!-- Stencil notifications -->
<chef-notification></chef-notification>

@if (isAccountDeactivated()) {
  <chef-ad-banner variant="red" [dismissible]="false">
    Your subscription is currently cancelled.
    <a class="underline" routerLink="/change-subscription"
      >Reactivate Account</a
    >
  </chef-ad-banner>
} @else if (pageNotification()) {
  <chef-ad-banner
    variant="teal"
    [dismissible]="false"
    [message]="pageNotification()"
  ></chef-ad-banner>
}

<!-- Stencil spinner -->
<chef-spinner></chef-spinner>

<main id="main" class="min-h-[596px]">
  <router-outlet></router-outlet>
</main>

@defer (when showAgeModal()) {
  <app-age-modal [modalId]="ageModalId" />
}

<!-- Footer -->
<lib-footer [options]="headerFooterOptions()"></lib-footer>

<!-- Stencil back-to-top -->
<chef-back-to-top></chef-back-to-top>
